export const API_URL = 'https://triyatri-backend.vercel.app';